import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-leaderboard-nickname-popup',
  templateUrl: './leaderboard-nickname-popup.page.html',
  styleUrls: ['./leaderboard-nickname-popup.page.scss'],
})
export class LeaderboardNicknamePopupPage implements OnInit {

  public nickNameForm: FormGroup;

  constructor(private modalController: ModalController) {
    this.nickNameForm = new FormGroup({
      nickName: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
  }

  onSubmit(){
    console.log("nickNameForm ", this.nickNameForm.value)
    this.dismissModal();
  }

  dismissModal() {
    this.modalController.dismiss();
  }

}
